import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

const isSpireonLogEdit =
  window.$environment?.SERVICE_PROVIDER === 'spireon' ||
  window.$environment?.CURRENT_LAYOUT === 'SpireonNew' ||
  window.$environment?.CURRENT_LAYOUT === 'SpireonOld';

const actionsColumn = {
  id: 'actions',
  ...(isSpireonLogEdit
    ? {
        label: i18n.t('common.actions'),
        align: 'right',
      }
    : {}),
};

export const statusList = [
  { value: 'OFF', label: 'OFF_DUTY' },
  { value: 'SB', label: 'SLEEPER_BERTH' },
  { value: 'DR', label: 'DRIVING' },
  { value: 'ON', label: 'ON_DUTY' },
];

export const enableEditOWColumns = [
  {
    id: 'status',
    numeric: false,
    disablePadding: true,
    label: i18n.t('logs.status'),
    needSorting: false,
  },
  {
    id: 'stateModifier',
    numeric: false,
    disablePadding: true,
    label: checkServiceProvider('enableEditOWColumns_stateModifier', window.$environment.SERVICE_PROVIDER, false),
    placeholder: i18n.t('common.pleaseSelect'),
    needSorting: false,
  },
  {
    id: 'time_from',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.timeFrom'),
    needSorting: false,
  },
  {
    id: 'time_to',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.timeTo'),
    needSorting: false,
  },
  {
    id: 'location',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.location'),
    needSorting: false,
  },
  {
    id: 'driverId',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.assignedDriver'),
    needSorting: false,
  },
  {
    id: 'note',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.notes'),
    needSorting: false,
  },
  actionsColumn,
];

export const disableEditOWColumns = [
  {
    id: 'status',
    numeric: false,
    disablePadding: true,
    label: i18n.t('logs.status'),
    needSorting: false,
  },

  {
    id: 'time_from',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.timeFrom'),
    needSorting: false,
  },
  {
    id: 'time_to',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.timeTo'),
    needSorting: false,
  },
  {
    id: 'location',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.location'),
    needSorting: false,
  },
  {
    id: 'driverId',
    numeric: false,
    disablePadding: false,
    label: i18n.t('logs.assignedDriver'),
    needSorting: false,
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: i18n.t('logs.notes'),
    needSorting: false,
  },
  actionsColumn,
];
